import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { LoaderService } from '../../../../shared/sharedServices/loader.service';
import { CommonHelper } from '../../../../utilities/common.helper';
import { HEC_CONSTANTS } from '../../../../../app/utilities/constants';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgForm } from '@angular/forms';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { UploadDocumentsService } from '../../upload-documents/upload-documents.service';
import { DesChallanService } from '../../../../views/pages/des-challan/services/des-challan.service';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-verify-challan',
  templateUrl: './verify-challan.component.html',
  styleUrls: ['./verify-challan.component.scss']
})
export class VerifyChallanComponent implements OnInit {
  @ViewChild('verifyChallanForm',{static:false}) verifyChallanForm: NgForm;

  private fileExt: string = HEC_CONSTANTS.CONSTANT_VALUES.fileExt;
  private maxSize: number = HEC_CONSTANTS.CONSTANT_VALUES.maxSize;
  public uploadData:any;
  public isAlertVisible:Boolean = false;
  public alertType:string;
  public alertMsgValue:string;
  files: any[] = [];
  public selectedFilePayload:any;
  public loader:boolean=false;
  public todayDate = new Date();
  public fileUploader:boolean=false;
  private attachmentBase64: string;
  public appId:number;
  public refNo:string;
  public userName:any;
  public disabledBtn:boolean=false;
  public isChallanSubmittedSuccess:boolean=false
  @ViewChild('fileDropRef',{static:false}) fileDropRef: ElementRef;
  constructor(private cdr:ChangeDetectorRef,private loaderService:LoaderService,private ng2ImgMax: Ng2ImgMaxService,
    private dialogRef: MatDialogRef<VerifyChallanComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private uploadSerivce:UploadDocumentsService,private sharedService:SharedService,private matDialog: MatDialog,
    private desChallanService:DesChallanService,private router:Router) { }

  ngOnInit() {
    this.appId = this.data.applicationId;
    this.refNo = this.data.refNo;
    this.getUserName();
    if(this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES_PAYMENT){
      this.getDocumentList('DES')
    }else if(this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES_PAYMENT){
      this.getDocumentList('DESF')

    }

  }

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  public getDocumentList(acronym) {
    this.loader = true;
    this.loaderService.setValue(this.loader)
    let payload = {
      data: {
        applicationId: this.appId,
        processAcronym: acronym
      }
    }
    this.uploadSerivce.getDocumentList(payload).subscribe(
      (res: HecResponse) => {
        if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
          for (let j = 0; j < res.data.length; j++) {
            if (res.data[j].category == 'Challan Payment') {
                  this.uploadData = res.data[j].documentId
            }
            

          }
          this.loader = false;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
        } else {
          this.loader = false;
          this.loaderService.setValue(this.loader)
        }
      }
    )
  }

  async prepareFilesList(e: Array<any>) {
    if(e.length > 1){
      return false;
    }
    let image = e[0];
    let test:File;  
    let file = e[0];
    if (this.isValidFile(file)) {
      this.fileUploader = true;
    this.cdr.detectChanges();
    if (file.type !== 'application/pdf') {
    // this.ng2ImgMax.compressImage(image, 0.575).subscribe(
    //   async result => {
    //     test = result;
      await this.setAttachmentsPayload(image);
      await this.uploadAttachment();
      // this.uploadAttachment();
      // if(this.uploadData == undefined){
      //   await this.uploadAttachment();
      // }
      // },
      // error => {
      //   console.log(error);
      //   this.fileUploader = false;
      //   this.cdr.detectChanges();
      // }
    // );
    }else{
      if(this.uploadData == undefined){
        await this.setAttachmentsPayload(image);
        await this.uploadAttachment();
      }
      
    }
    for (const item of e) {
      item.progress = 0;
      this.files.push(item);
    }
    
    this.uploadFilesSimulator(0);
  }else{
    e=undefined
    file=undefined
    this.fileDropRef.nativeElement.value = null
  }
  }

  uploadFilesSimulator(index: number) {
    setTimeout(() => {
      if (index === this.files.length) {
        return;
      } else {
        const progressInterval = setInterval(() => {
          if (this.files[index].progress === 100) {
            clearInterval(progressInterval);
            this.uploadFilesSimulator(index + 1);
            this.fileUploader=false;
            this.cdr.detectChanges();
          } else {
            this.files[index].progress += 5;
          }
        }, 200);
      }
    }, 1000);
  }

  private isValidFile(file) {
    const extensions = (this.fileExt.split(',')).map(function (x) { return x.toLocaleLowerCase().trim(); }); // array of extensions
    const ext = file.name.toLowerCase().split('.').pop() || file.name; // file extension
    const fileSizeinKB = file.size / 1024;

    if (extensions.indexOf(ext) === -1) {
      this.alertType='warning';
      this.alertMsgValue='Error in uploading ' + file.name + ' due to invalid file type.';
      // this.isAlertVisible=true;
      this.sharedService
          .openPopupDialog(
            'ERROR',
            'Error in uploading ' + file.name + ' due to invalid file type.',
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then((res) => {
          });
      this.cdr.detectChanges();
      // setTimeout(() => {
      //   this.isAlertVisible = false;
      //   this.cdr.detectChanges();
      // }, 6000);   
      return false;
    } else if (!file.name.match(HEC_CONSTANTS.CONSTANT_VALUES.fileAllowedFormat)) {
      this.alertType='warning';
      this.alertMsgValue='Invalid File Name';
      // this.isAlertVisible=true;
      this.sharedService
      .openPopupDialog(
        'ERROR',
        'Invalid File Name',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
      this.cdr.detectChanges();
      // setTimeout(() => {
      //   this.isAlertVisible = false;
      //   this.cdr.detectChanges();
      // }, 6000);   
      return false;
    } 
    else if (fileSizeinKB > this.maxSize) {
      this.alertType='warning';
      this.alertMsgValue=file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.';
      // this.isAlertVisible=true;
      this.sharedService
      .openPopupDialog(
        'ERROR',
        file.name + ' ( ' + (fileSizeinKB / 1024).toFixed(2) + 'MB )' + ' exceeds file size limit of ' + (this.maxSize / 1024).toFixed(2) + 'MB.',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
      this.cdr.detectChanges();
      // setTimeout(() => {
      //   this.isAlertVisible=false;
      //   this.cdr.detectChanges();
      // }, 6000);   
      return false;
    }
    return true;
  }

  private async setAttachmentsPayload(file) {
    this.attachmentBase64 = (await this.convertFileToBase64(file)).toString();
  }

  private convertFileToBase64(file): any {
    return new Promise((resolve, reject) => {
      CommonHelper.convertFileToBase64(file).then((result) => {
        resolve(result);
      })
        .catch(function (error) {
          console.log(error)
          resolve(null);
        })
    })
  }


  private uploadAttachment() {   
    return new Promise((resolve, reject) => {
    this.loader=true;
    this.loaderService.setValue(this.loader)
    this.selectedFilePayload = '';
    this.selectedFilePayload = this.attachmentBase64;
    let acronym;
    if(this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES_PAYMENT){
      acronym = 'DES';
    }else if(this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES_PAYMENT){
      acronym = 'DESF';

    }
    let payload = {
      data: {
          applicationId: this.appId,
          addedBy:this.userName,
          content: this.selectedFilePayload,
          processAcronym: acronym,
          category: 'Challan Payment',
          title: 'Challan Payment',
          description: 'Challan Payment',
      }
    }
    this.uploadSerivce.uploadDocument(payload)
      .subscribe(
        (res:HecResponse) => {
          if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
            this.loader=false;
            this.loaderService.setValue(this.loader)
            this.uploadData = res.data.documentId
            this.isAlertVisible = false;
            resolve(this.uploadData)
          }
          else{
            this.loader=false;
            this.loaderService.setValue(this.loader)
          this.alertType='error';
          this.alertMsgValue='Something went wrong please try again or contact administrator.';
          // this.isAlertVisible=true;
          this.sharedService
      .openPopupDialog(
        'ERROR',
        'Something went wrong please try again or contact administrator.',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
          }
        },
        (err) => {
          this.loader=false;
          this.loaderService.setValue(this.loader)
          this.alertType='error';
          this.alertMsgValue='Something went wrong please try again or contact administrator.';
          // this.isAlertVisible=true;
          this.sharedService
      .openPopupDialog(
        'ERROR',
        'Something went wrong please try again or contact administrator.',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
        }
      )
    });
  }

  public getUserName(){
    this.sharedService.getPersonalDetails().subscribe(
      (res)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.userName = res.data.authenticationName;
        }
      }
    )
    window.scroll(0,0)

  }

  public submitChallan(){
    CommonHelper.markFormGroupTouched(this.verifyChallanForm);
    if(this.validate(this.verifyChallanForm)){
    if (this.validate(this.verifyChallanForm) && this.uploadData){
      this.loader = true;
      this.loaderService.setValue(this.loader)
    if (this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES_PAYMENT) {
      this.claimTask(this.verifyChallanForm.value,'des');      
    }else if(this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES_PAYMENT){
      
      this.claimTask(this.verifyChallanForm.value,'desf');      

    }
    }else{
      this.alertMsgValue = 'Upload Paid Payment Challan is required';
      // this.isAlertVisible = true;
      this.sharedService
      .openPopupDialog(
        'ERROR',
        'Upload Paid Payment Challan is required',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
      
      
    }}else{
      this.alertMsgValue = 'Please fill all the required fields.';
      // this.isAlertVisible = true;
      this.sharedService
      .openPopupDialog(
        'ERROR',
        'Please fill all the required fields.',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
      this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
    }
      // return;
    
    // this.accept(this.verifyChallanForm.value)
  }

  public claimTask(reqData,acronym):void{
    this.desChallanService.claimTask('Payment Verification',this.appId,acronym).subscribe(
      (res:HecResponse)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
        this.submitChallanVerificationData(reqData,acronym)
        }else{
            this.loader = false;
    this.loaderService.setValue(this.loader)
          this.alertMsgValue = 'Something went wrong!';
          // this.isAlertVisible = true;
          this.sharedService
      .openPopupDialog(
        'ERROR',
        'Something went wrong!',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
        }
      },
      (err)=>{
        this.loader = false;
        this.loaderService.setValue(this.loader)
        this.alertMsgValue = 'Something went wrong!';
          // this.isAlertVisible = true;
          this.sharedService
      .openPopupDialog(
        'ERROR',
        'Something went wrong!',
        HEC_CONSTANTS.ERROR_TYPES.error
      )
      .then((res) => {
      });
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
      }
    )
  }

  submitChallanVerificationData(reqData,acronym):void{
    let payload = {
      data:reqData
    }
    payload.data.id = this.appId;
    payload.data.challanDate = this.sharedService.getDate(reqData.challanDate)
    this.desChallanService.savePayment(payload,acronym).subscribe(
      (res:HecResponse)=>{
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          this.alertMsgValue = 'Challan Successfully Submitted';
          // this.isAlertVisible = true;
          this.isChallanSubmittedSuccess =true
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
          this.loader = false;
          this.loaderService.setValue(this.loader)
          this.cdr.detectChanges();
          // setTimeout(()=>{
          //   this.accept();
          // },2000)
          this.sharedService
      .openPopupDialog(
        'Success',
        'Challan Successfully Submitted',
        HEC_CONSTANTS.ERROR_TYPES.success
      )
      .then((res) => {
        this.accept();
      });
        }else{
          this.loader = false;
          this.loaderService.setValue(this.loader)
          this.alertMsgValue = 'Something went wrong!';
          // this.isAlertVisible = true;
          this.sharedService
          .openPopupDialog(
            'Error',
            'Something went wrong!',
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then((res) => {
          });
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
          this.cdr.detectChanges()
        }
      },
      (err)=>{
        this.loader = false;
          this.loaderService.setValue(this.loader)
        this.alertMsgValue = 'Something went wrong!';
          // this.isAlertVisible = true;
          this.sharedService
          .openPopupDialog(
            'Error',
            'Something went wrong!',
            HEC_CONSTANTS.ERROR_TYPES.error
          )
          .then((res) => {
          });
          this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
      }
    )
  }

  public validate(f): boolean {
    if (f.status === 'VALID') {
      return true;
    }
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss(type) {
    this.dialogRef.close(false);
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  public deleteUploadDoc(){
    this.loader = true;
    this.loaderService.setValue(this.loader)
     let payload = {
       data: {
         documentId: this.uploadData,
         acronym: 'DAS'
       }
     }
     this.uploadSerivce.deleteDocument(payload).subscribe(
       (res:HecResponse)=>{
         this.loader=false;
         this.loaderService.setValue(this.loader)
         if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
           this.uploadData = undefined;
           this.deleteFile(0)
         }
       }
     )
   }

   deleteFile(index: number) {
    this.files.splice(index, 1);
  }

   public downloadDocument(){
    this.loader=true;
    this.loaderService.setValue(this.loader)
    if(this.uploadData){
      let payload = {
        data: {
            documentId: this.uploadData,
            acronym: 'DAS'
        }
      }
      this.uploadSerivce.getAttachmentByDocumentId(payload).subscribe(
        (res:HecResponse)=>{
          this.loader=false;
          this.loaderService.setValue(this.loader)
          if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
            // this.saveFile(res.data.content)
            if (res.data.path.toLowerCase().split('.').pop() != 'pdf') {
              this.ModalComponent(DocumentViewerComponent, res.data.path.toLowerCase().split('.').pop(), res.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-two')
            } else {
              this.ModalComponent(PdfViewerComponent, res.data.path.toLowerCase().split('.').pop(), res.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-three')
            }
          }
        }
      )
    }
  }

  public ModalComponent(component, imageType, imageContent, backdropClass?, panelClass?) {
    const dialogRef = this.matDialog.open(component, {
      width: '70vw',
      height: '60vh',
      backdropClass: backdropClass,
      panelClass: panelClass,
      disableClose: true,
      autoFocus: false,
      data: { imageType: imageType, imageContent: imageContent }
    });
  }
   
}
